//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import experimentMixin from '@motionelements/core/src/components/mixins/experiment.mixin.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { listCurations } from '@/api/channels.js';

export default {
  name: 'SubscribeCurations',
  mixins: [experimentMixin, featureFlagMixin],
  data() {
    return {
      curations: [],
      isCurationsLoading: false,
    };
  },
  computed: {
    curationLink() {
      return (curation) => _.get(curation, 'html.url');
    },
    curationImage() {
      return (curation) => _.get(curation, 'backgroundImage.url');
    },
  },
  async fetch() {
    return this.listCurations();
  },
  methods: {
    async listCurations() {
      this.isCurationsLoading = true;
      return listCurations('subscribe', {
        page: 1,
        per_page: 3,
        'fields[page]': 'heading,background_image,html',
      })
        .then((response) => {
          // console.log(response.data);
          // response.data.data[0].backgroundImage.url = 'https://thumb.r2.moele.me/t/15448/15438207/a-0120.jpg';
          // Array.from({ length: 14 }).forEach(() => {
          //   response.data.data.push(response.data.data[0]);
          // });
          const curations = _.get(response, 'data.data');
          this.curations = curations ? curations : [];
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isCurationsLoading = false;
        });
    },
  },
};
